import reducer from 'src/utils/redux/reducer';
import {GAPI_LOADED, GAPI_CHECKING} from './types';

// --- initialState ---

export const initialState = {
  loaded: false,
  checking: false,
};

// --- handlers ---

const handleSetInitial = () => initialState;

const handleGapiLoaded = (state, action) => ({ ...state, loaded: action.loaded });

const handleGapiChecking = (state, action) => ({ ...state, checking: action.checking });

const handlers = {
  'SET_INITIAL': handleSetInitial,
  [GAPI_LOADED]: handleGapiLoaded,
  [GAPI_CHECKING]: handleGapiChecking,
};

// --- reducerFactory ---

export default flows => reducer({ initialState, handlers, flows });